const keys = {
  sleeping: "sleeping",
  drinking_nightlife: "drinking_nightlife",
  transport: "transport",
  activities: "activities",
  entertainment: "entertainment",
  shopping: "shopping",
  eating: "eating",
  sights: "sights",
  info: "info",
  festivals_events: "festivals_events",
};

const poiTypes = {
  [keys.sleeping]: {
    name: keys.sleeping,
    displayName: "Hotels",
    schemaType: "LodgingBusiness",
  },
  [keys.drinking_nightlife]: {
    name: keys.drinking_nightlife,
    displayName: "Nightlife",
    schemaType: "BarOrPub",
  },
  [keys.transport]: {
    name: keys.transport,
    displayName: "Transportation",
    schemaType: "Place",
  },
  [keys.activities]: {
    name: keys.activities,
    displayName: "Activities",
    schemaType: "TouristAttraction",
  },
  [keys.entertainment]: {
    name: keys.entertainment,
    displayName: "Entertainment",
    schemaType: "EntertainmentBusiness",
  },
  [keys.shopping]: {
    name: keys.shopping,
    displayName: "Shopping",
    schemaType: "Store",
  },
  [keys.eating]: {
    name: keys.eating,
    displayName: "Restaurants",
    schemaType: "Restaurant",
  },
  [keys.sights]: {
    name: keys.sights,
    displayName: "Attractions",
    schemaType: "TouristAttraction",
  },
  [keys.info]: {
    name: keys.info,
    displayName: "Information",
    schemaType: "Place",
  },
  [keys.festivals_events]: {
    name: keys.festivals_events,
    displayName: "Events",
    schemaType: "Event",
  },
};

export { poiTypes };



// WEBPACK FOOTER //
// ../server/lib/open-planet/poiTypes.js